var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDomainInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 150,
    viewBox: "0 0 250 150"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7FE",
    fillRule: "nonzero",
    d: "M124.845 15h.31C158.207 15 185 41.793 185 74.845v.31C185 108.207 158.207 135 125.155 135h-.31C91.793 135 65 108.207 65 75.155v-.31C65 41.793 91.793 15 124.845 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89CFF8",
    fillRule: "nonzero",
    d: "M185 74.845v.31A59.587 59.587 0 01172.318 112C165.498 111.9 160 106.343 160 99.5V96a9 9 0 019-9h2a7 7 0 000-14h-24.5c-6.904 0-15.5-5.596-15.5-12.5V55a7 7 0 017-7 7 7 0 007-7v-1.5a8.5 8.5 0 018.5-8.5h12.387C177.644 41.928 185 57.527 185 74.845zm-120 .31v-.31c0-3.354.276-6.642.806-9.845h4.232c5.93 0 11.176 3.845 12.962 9.5l.352 1.114A12 12 0 0094.795 84H114v13.042c0 4.723-2.109 9.2-5.75 12.208a15.835 15.835 0 00-5.75 12.208v6.042c0 1.048-.12 2.069-.346 3.049C80.354 121.609 65 100.176 65 75.155zm46-58.546v6.792a7.464 7.464 0 01-5.5 7.201 7.464 7.464 0 00-5.5 7.201v4.8c0 5.798-4.701 10.5-10.5 10.5H69.072C76.14 34.987 91.776 21.162 111 16.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75C7F7",
    fillRule: "nonzero",
    d: "M82.981 117.92a60.037 60.037 0 01-11.362-15.38 7.003 7.003 0 0111.104 3.503 6.001 6.001 0 01.258 11.877z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8EFFD",
    fillRule: "nonzero",
    d: "M185 74.845v.31C185 108.207 158.207 135 125.155 135h-.31c-12.01 0-23.192-3.537-32.563-9.626A59.728 59.728 0 00112.845 129h.31C146.207 129 173 102.207 173 69.155v-.31c0-21.043-10.86-39.549-27.282-50.219C168.64 27.013 185 49.018 185 74.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75C7F7",
    fillRule: "nonzero",
    d: "M185 74.845v.31A59.587 59.587 0 01172.318 112c-4.914-.07-9.141-2.976-11.12-7.153A59.653 59.653 0 00170.293 87H171a7 7 0 001.862-13.75 60.73 60.73 0 00.138-4.095v-.31A59.597 59.597 0 00159.517 31h6.37C177.644 41.928 185 57.527 185 74.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EB7F5",
    fillRule: "nonzero",
    d: "M177.039 45h-8.978a59.79 59.79 0 00-7.032-12.07 8.152 8.152 0 011.506-1.93h3.352a60.102 60.102 0 0111.152 14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75C7F7",
    fillRule: "nonzero",
    d: "M163.624 121A59.64 59.64 0 01138 133.618V132.5c0-6.351 5.149-11.5 11.5-11.5h14.124zm-61.47 9.549a59.673 59.673 0 01-9.872-5.175 59.412 59.412 0 0010.205 2.733c-.037.836-.15 1.652-.333 2.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EB7F5",
    fillRule: "nonzero",
    d: "M177.039 45h-8.978a59.79 59.79 0 00-7.032-12.07 8.152 8.152 0 011.506-1.93h3.352a60.102 60.102 0 0111.152 14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8EFFD",
    d: "M152.045 102.481a2.993 2.993 0 012.222 1.032l9.185 10.566a3 3 0 11-4.528 3.936l-9.185-10.566a2.993 2.993 0 01-.713-2.344l-3.83-4.406c-11.234 8.374-27.354 6.547-36.696-4.199-9.783-11.254-8.427-28.028 2.827-37.811 11.254-9.783 28.308-8.59 38.09 2.664 9.343 10.746 8.677 26.78-1.201 36.723l3.83 4.405zm-7.915-6.057c9.587-8.333 10.603-22.86 2.27-32.447-8.335-9.587-22.862-10.603-32.449-2.27-9.586 8.334-10.785 22.706-2.451 32.293s23.043 10.758 32.63 2.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75C7F7",
    fillRule: "nonzero",
    d: "M155.344 73H146.5c-6.904 0-15.5-5.596-15.5-12.5V55c0-1.046.23-2.038.64-2.929a26.907 26.907 0 0117.738 9.157A26.88 26.88 0 01155.344 73zm-52.94 11H114v13.042c0 1.346-.171 2.672-.5 3.95a27.236 27.236 0 01-5-4.492 26.621 26.621 0 01-6.096-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8EFFD",
    d: "M53.455 21.629a1.41 1.41 0 01-.593 1.967l-12.565 6.243a.532.532 0 01-.531-.92l11.69-7.76a1.41 1.41 0 012 .47zM59.44 27.588a1.41 1.41 0 01.469 2l-7.76 11.69a.532.532 0 01-.92-.531l6.244-12.565a1.41 1.41 0 011.966-.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#75C7F7",
    d: "M168 45h-1.11v-.024c-4.383-.153-7.89-3.723-7.89-8.106a8.062 8.062 0 012.806-6.115L168 45z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.725,
    cy: 22.239,
    r: 8.5,
    fill: "#B0DFFB",
    transform: "rotate(45 58.725 22.24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89CFF8",
    d: "M52.714 28.25a8.5 8.5 0 010-12.021s1.63 3.752 4.95 7.071c3.32 3.32 7.071 4.95 7.071 4.95a8.5 8.5 0 01-12.02 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8EFFD",
    d: "M55.543 25.421a1.41 1.41 0 01-.064 2.053l-10.522 9.284a.532.532 0 01-.75-.752l9.283-10.52a1.41 1.41 0 012.053-.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4E7FC",
    d: "M77.214 113.996v.018H65.846l.009-.016a5 5 0 01-1.843-9.587 7 7 0 0113.71-2.368 6.001 6.001 0 01-.508 11.953zM155 32.87c0-4.149 3.142-7.57 7.196-8.053 1.155-3.938 4.822-6.817 9.168-6.817 5.271 0 9.545 4.237 9.545 9.463 0 .186-.005.371-.016.555 2.417 1.04 4.107 3.426 4.107 6.204 0 3.667-2.946 6.652-6.62 6.756l.011.022h-15.5v-.024c-4.384-.153-7.891-3.723-7.891-8.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8EFFD",
    d: "M202.086 23.141l-.896-.331a.864.864 0 010-1.62l.896-.331a3 3 0 001.773-1.773l.331-.896a.864.864 0 011.62 0l.331.896a3 3 0 001.773 1.773l.896.331a.864.864 0 010 1.62l-.896.331a3 3 0 00-1.773 1.773l-.331.896a.864.864 0 01-1.62 0l-.331-.896a3 3 0 00-1.773-1.773zm-6.476 94.765l-.658-.216a.651.651 0 010-1.238l.658-.216a2.55 2.55 0 001.626-1.626l.216-.658a.651.651 0 011.238 0l.216.658a2.55 2.55 0 001.626 1.626l.658.216a.651.651 0 010 1.238l-.658.216a2.55 2.55 0 00-1.626 1.626l-.216.658a.651.651 0 01-1.238 0l-.216-.658a2.55 2.55 0 00-1.626-1.626zM22.532 56.487l-.79-.26a.782.782 0 010-1.484l.79-.26a3.06 3.06 0 001.951-1.95l.26-.79a.782.782 0 011.485 0l.26.79a3.06 3.06 0 001.95 1.95l.79.26a.782.782 0 010 1.485l-.79.26a3.06 3.06 0 00-1.95 1.95l-.26.79a.782.782 0 01-1.485 0l-.26-.79a3.06 3.06 0 00-1.95-1.95z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 83.5,
    r: 2.5,
    fill: "#D8EFFD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 52,
    r: 2,
    fill: "#D8EFFD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 53,
    x: 98,
    y: 49,
    fill: "#FFF",
    rx: 25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8EFFD",
    d: "M137.216 53.433c5.618 3.89 9.565 10.023 10.546 17.104C144.662 61.497 136.09 55 126 55c-12.703 0-23 10.297-23 23s10.297 23 23 23c2.455 0 4.82-.384 7.037-1.097A24.915 24.915 0 01123 102c-8.467 0-15.952-4.21-20.474-10.65A26.877 26.877 0 0199 78c0-14.912 12.088-27 27-27 4.002 0 7.8.87 11.216 2.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EB7F5",
    fillRule: "nonzero",
    d: "M111.994 82h-2.808l-2.178-8.748h-.036L104.83 82h-2.862l-3.402-12.852h2.826l2.034 8.748h.036l2.232-8.748h2.646l2.196 8.856h.036l2.106-8.856h2.772L111.994 82zm16.992 0h-2.808L124 73.252h-.036L121.822 82h-2.862l-3.402-12.852h2.826l2.034 8.748h.036l2.232-8.748h2.646l2.196 8.856h.036l2.106-8.856h2.772L128.986 82zm16.992 0h-2.808l-2.178-8.748h-.036L138.814 82h-2.862l-3.402-12.852h2.826l2.034 8.748h.036l2.232-8.748h2.646l2.196 8.856h.036l2.106-8.856h2.772L145.978 82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#459FED",
    d: "M142.696 94.53l5.19 6.185-3.065 2.57-5.19-6.184c-11.365 8.201-27.306 6.35-36.459-4.557-9.585-11.423-8.095-28.454 3.328-38.039s28.454-8.095 38.039 3.328c9.152 10.908 8.207 26.929-1.843 36.697zm-4.056-1.722c9.73-8.165 11-22.673 2.835-32.404-8.165-9.73-22.673-11-32.403-2.834-9.731 8.165-11 22.672-2.835 32.403 8.165 9.73 22.672 11 32.403 2.835z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 20,
    x: 147.853,
    y: 97.275,
    fill: "#3791DF",
    rx: 3,
    transform: "rotate(-40 150.853 107.275)"
  }))));
}

export default __webpack_public_path__ + "media/DomainInfoIcon.4619db5d.svg";
export { SvgDomainInfoIcon as ReactComponent };